module.exports = __webpack_public_path__ + "img/www.twitter.com.2890bac9.png";